// Conexión SIMULADA a la guía de valores (demo). Valores = ofertas públicas del mercado, no de Fasecolda.
// Método de Fasecolda para usados (metodología publicada): 1) preprocesar, 2) quitar atípicos, 3) unificar en un precio.
import datos from '../datos/valuador-mercado.json';

const sinTildes = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
const cuantil = (xs, q) => { const p = (xs.length - 1) * q; const b = Math.floor(p); return xs[b] + (xs[b + 1] !== undefined ? (p - b) * (xs[b + 1] - xs[b]) : 0); };
const redondear = (n) => Math.round(n / 100000) * 100000;

export function buscarModelo(texto) {
  const t = sinTildes(texto);
  const anio = Number((t.match(/(19|20)\d{2}/) || [])[0]);
  return Object.entries(datos.modelos).find(([, m]) => m.anio === anio && m.alias.some((a) => t.includes(a)) && !(m.excluye || []).some((x) => t.includes(x))) || null;
}

// Devuelve el valor de referencia y el rastro del cálculo (para el asesor y la Vista Junta)
export function valorComercial(texto) {
  const hit = buscarModelo(texto);
  if (!hit) return null;
  const [codigo, m] = hit;
  const xs = [...m.precios].sort((a, b) => a - b);
  const q1 = cuantil(xs, 0.25); const q3 = cuantil(xs, 0.75); const iqr = q3 - q1;
  const limpias = xs.filter((x) => x >= q1 - 1.5 * iqr && x <= q3 + 1.5 * iqr);
  return {
    codigo: `SIM-${codigo.toUpperCase()}`,
    vehiculo: `${m.marca} ${m.linea} ${m.anio}`,
    valor: redondear(cuantil(limpias, 0.5)),
    rango: [redondear(cuantil(limpias, 0.25)), redondear(cuantil(limpias, 0.75))],
    ofertas: xs.length,
    atipicas: xs.length - limpias.length,
    fecha: datos.fecha,
    fuente: datos.fuente,
  };
}
